import { AIActions, selectAIGenerating } from '@store/reducers/ai'
import type { AIChatClarifyMessage } from '@store/reducers/ai/types'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ActionButton, ActionsMessage, AIMessage } from '../../../index'

interface ClarifyOptionsMessageProps {
  message: AIChatClarifyMessage
  showOptions: boolean
}

export const ClarifyOptionsMessage: React.FC<ClarifyOptionsMessageProps> = ({
  message,
  showOptions,
}) => {
  const dispatch = useDispatch()
  const generating = useSelector(selectAIGenerating)

  const onOptionClick = (label: string) => {
    if (generating) {
      return
    }

    dispatch(AIActions.sendMessage({ message: label }))
  }

  return (
    <>
      <AIMessage>{message.text}</AIMessage>
      {showOptions && message.options.length > 0 && (
        <ActionsMessage>
          {message.options.map((option) => (
            <ActionButton
              key={option.id}
              variant="purple"
              onClick={() => onOptionClick(option.label)}
            >
              {option.label}
            </ActionButton>
          ))}
        </ActionsMessage>
      )}
    </>
  )
}
